import $ from "jquery";

/**
 * This class handles on-scroll animations.
 *
 * ** HOW TO USE IT: **
 * Each element that has an on-scroll animation should have the
 * `.on-scroll-anim` class name.
 *
 * When the animation is to be triggered, that class name will be
 * removed. You can use this functionality to animate the element
 * with css.
 *
 * ** HOW IT WORKS **
 * When an on-scroll element enters the viewport, it is added to
 * the `animQueue` array.
 *
 * Each element in the `animQueue` has it's animation triggered,
 * one-by-one, at a delay. That delay can be adjusted (triggerDelay).
 *
 */

// Adjustable Variables
var triggerDelay = 50; // ms - Delay between elements animation's triggering
var verticalScreenView = 0.85; // % - Height of the viewport to test against element positions

// onScrollHandler
export default class onScrollHandler {
  constructor() {
    this.scrollEls = [];
    this.animQueue = [];

    // Is the queue active?
    this.queueIsActive = false;

    // Load up all of the on-scroll-elements
    this.loadElements.bind(this);
    this.loadElements();

    // On user scroll
    $(window).on("scroll", this.onScroll.bind(this));
    setTimeout(this.onScroll.bind(this), 750);
  }

  // Load up the elements
  loadElements() {
    var domScrollEls = $(".on-scroll-anim");

    for (var i = 0; i < domScrollEls.length; i++) {
      var domScrollEl = domScrollEls.eq(i);
      this.scrollEls.push(domScrollEl);
    }
  }

  // On user scroll
  onScroll() {
    var queueShouldTrigger;
    // Check if any of the scrollEls are in the viewport
    for (var i = 0; i < this.scrollEls.length; i++) {
      var scrollEl = this.scrollEls[i];
      var scrollElTop = scrollEl.offset().top;
      var scrollElBottom = scrollElTop + scrollEl.height();
      var screenTop =
        $(window).scrollTop() +
        window.innerHeight -
        window.innerHeight * verticalScreenView;
      var screenBottom =
        $(window).scrollTop() + window.innerHeight * verticalScreenView;
      var hasViewedAttr = scrollEl.attr("data-hasviewed");

      // Check if this element is within the viewport
      if (scrollElTop <= screenBottom && scrollElBottom >= screenTop) {
        // Add this element to the queue if it hasn't already been.
        if (hasViewedAttr !== "true") {
          this.animQueue.push(scrollEl);
          scrollEl.attr("data-hasviewed", "true");
        }

        // Trigger the animation queue if it is not
        // already active.
        if (this.queueIsActive === false && this.animQueue.length > 0) {
          queueShouldTrigger = true;
        }
      }
    }

    // Triggering the queue
    if (queueShouldTrigger === true) {
      this.queueIsActive = true;
      this.triggerQueue();
    }
  }

  // Animate an element in the queue
  triggerQueue() {
    var element = this.animQueue[0];

    // Remove the class, executing the animation
    element.removeClass("on-scroll-anim");

    // Remove the element from the animQueue as it
    // has now been animated.
    this.animQueue.splice(0, 1);

    // If the queue still has elements in it, animate
    // the next one. If not, set the queue as not active.
    if (this.animQueue.length > 0) {
      setTimeout(this.triggerQueue.bind(this), triggerDelay);
    } else {
      this.queueIsActive = false;
    }
  }
}
